import DataGrid, { Column, Paging, Scrolling } from 'devextreme-react/data-grid';
import React from 'react';

export default function MasterDetailGrid(prop) {

  return (
    <DataGrid
      dataSource={prop.data.data.roles}
      showBorders={false}
      remoteOperations={true}
      height={300}
    >
      <Scrolling columnRenderingMode="virtual" />
      <Paging enabled={false} />
      {/* <Column dataField="RoleId" selectedFilterOperation={"contains"} caption="Rol ID" alignment="center" /> */}
      <Column dataField="description" selectedFilterOperation={"contains"} caption="Rol Adı" alignment="center" />
    </DataGrid>
  );
}